export default __webpack_public_path__ + "static/media/maestro.f27820b0.png";